import React, { useRef,useEffect,useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { format } from "date-fns";
import sign from "../../../assest/images/Singn.png";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useUserDetails } from "../../../context/auth";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ReusablePDFLayout from "../ReusablePDFLayout";
import moment from "moment";
import { toWords } from "number-to-words";
export const Offer = () => {
  const pdfRef = useRef();
 const { MainId ,RowIDdata} = useUserDetails();



  const [Salarydata, setSalarydata] = useState([]);
  const [Finaldata, setFinaldata] = useState([]);
  const [Earning, setEarning] = useState([]);
  const [Deductions, setDeductions] = useState([]);
  const [Benefits, setBenefits] = useState([]);
  useEffect(() => {
   
    onDepartmentdata();
  
 
  }, []);

  const onDepartmentdata = async () => {
    const query = `query GetAllOfferSalaries {
  allOfferSalaries {
    id
    recruitmentProcess {
      id
    }
    salaryStructure {
      id
    }
    basicPercentage
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    breakdown
  }
}`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allOfferSalaries;
    
      

      let filtevalue = departmentList?.filter((val)=> val.recruitmentProcess.id == MainId)

    
      let iddata = filtevalue[0]?.id
      setTimeout(() => {
        Getsalary(iddata)
      }, 1000);
      
      setFinaldata(filtevalue)

    } catch (error) {
      console.error("ResponseError:", error);
    }
  };


  const Getsalary = async (id) => {
    const query = `query GetOfferSalaryById($id: Int!) {
  offerSalary(id: $id) {
    id
    recruitmentProcess {
      id
    }
    salaryStructure {
      id
    }
    basicPercentage
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    date
    overallSum
    difference
    breakdown
  }
}`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id: id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

  
      let offerSalary = response.data?.data?.offerSalary;

      
   
      // Ensure breakdown is correctly parsed into an array
      let breakdown =
        typeof offerSalary?.breakdown === "string"
          ? JSON.parse(JSON.parse(offerSalary.breakdown)) // DOUBLE PARSE
          : offerSalary?.breakdown;

      

      setSalarydata(response.data.data.offerSalary);

      let earnings = breakdown.filter((val) => val.type == "Earnings");
      let deduction = breakdown.filter((val) => val.type == "Deductions");
      let benefits = breakdown.filter((val) => val.type == "Benefits");
      const gratuity = benefits.find(
        (item) => item.componentName === "GRATUITY"
      );
      const finalData = [...deduction, gratuity];

      setEarning(earnings);
      setDeductions(finalData);
      setBenefits(benefits);

      //  setBreakdown(breakdownData)
    } catch (error) {
    }
  };

  

  let EarningData = Earning.filter((val) => /^[A-Za-z]/.test(val.componentName)) // Filters only alphabetic names
    .sort((a, b) => a.componentName.localeCompare(b.componentName)); // Sorts alphabetically

  let Deductiondata = Deductions.filter((val) =>
    /^[A-Za-z]/.test(val.componentName)
  ) // Filters only alphabetic names
    .sort((a, b) => a.componentName.localeCompare(b.componentName)); // Sorts alphabetically

  
  let Benefitsdata = Benefits.filter((val) =>
    /^[A-Za-z]/.test(val.componentName)
  ) // Filters only alphabetic names
    .sort((a, b) => a.componentName.localeCompare(b.componentName)); // Sorts alphabetically

  

  const generatePDF = async () => {
    const input = pdfRef.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Add the first page
    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Loop to handle multi-page content (if heightLeft is more than 0, continue adding pages)
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save PDF
    pdf.save("npa.pdf");
  };
  const headerStyle = {
    backgroundColor: "#d9d9d9",
    fontWeight: "bold",
  };

  const totalRowStyle = {
    backgroundColor: "#d9d9d9",
  };

  const formattedDate = moment(Salarydata?.date).format("DD MMMM YYYY");
  

  const Dateformat = moment(new Date().toLocaleDateString()).format("DD MMMM YYYY");



  const NextDateformat = moment().add(1, "days").format("DD MMMM YYYY");
  
  
  
  

  // const ctcAmount = Salarydata?.ctc || 0;
  // const ctcInWords = toWords(ctcAmount);
  
  


const formatNumberWithCommas = (num) => {
  return num.toLocaleString("en-IN"); // Indian number format with commas
};

const numberToWords = (num) => {
  if (!num) return "";
  return toWords(num).replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize words
};

// Example usage
const ctcAmount = Salarydata?.ctc || 0;
const formattedCTC = formatNumberWithCommas(ctcAmount);
const ctcInWords = numberToWords(ctcAmount);

const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const candidateName = capitalizeFirstLetter(RowIDdata[0]?.candidateName);



        

  return (
    <DashboardLayout>
      <div>
      <div 
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
      }}
    >
      {/* <button 
        style={{
          background: "none",
          border: "none",
          color: "#007BFF",
          fontSize: "18px",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        Back
      </button> */}

      <button 
        onClick={generatePDF} 
        style={{
          padding: "10px 15px",
          backgroundColor: "#007BFF",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
          fontSize: "14px",
          fontWeight: "bold",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          transition: "background-color 0.3s ease",
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
        onMouseOut={(e) => e.target.style.backgroundColor = "#007BFF"}
      >
        Download PDF
      </button>
    </div>
   

        {/* Parent container for PDF */}
        <div
          ref={pdfRef}
          style={{
            backgroundColor: "white", // Ensure proper background
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "210mm",
            padding: "0",
             marginLeft:'10%'
          }}
        >
          <ReusablePDFLayout>
            <div className="parentcls">
              <div style={{ display: "flex", width: "100%" }}>
                <p className="boloff" style={{ width: "80%" }}>
                  <span
                    style={{
                      borderBottom: "2px solid black",
                      marginLeft: "89px",
                    }}
                  >
                    OFFER LETTER
                  </span>{" "}
                </p>
                <p className="boloff" style={{ width: "25%" }}>
                  <b>{Dateformat}</b>{" "}
                </p>
              </div>
              <p style={{ margin: "30px 0" }} className="paraoff">
                Dear <b>{capitalizeFirstLetter(RowIDdata[0]?.candidateName)}</b>,
              </p>
              <p style={{ margin: "15px 0" }} className="paraoff">
                Congratulations!{" "}
              </p>
              <p style={{ margin: "10px 0 30px 0" }} className="paraoff">
                We are pleased to confirm that you have been selected to work
                with Keel Info Solution Private Limited. We are delighted to
                share with you the following job offer.{" "}
              </p>
              <p className="paraoff">
                You have been selected for the position of{" "}
                <span className="boldsoff">{RowIDdata[0]?.position}</span> with an annual cost to
                the company of{" "}
                <span className="boldsoff"> Rs.{formattedCTC} ({`${ctcInWords} Only` })</span> . This
                includes all monthly payments, incentives and annual payments
                fully described in Annexure A herewith. The salary offered also
                includes communication/internet charges incurred during your
                work with the organization and there would be no separate
                reimbursement for the same. However, your appointment will be
                valid subject to receipt of requisite documents and satisfactory
                references provided by you.
              </p>
              <p className="paraoff" style={{ margin: "30px 0" }}>
                Your work with us will start on <span className="boldsoff">{formattedDate}</span> at{" "}
                <span className="boldsoff">11 am </span> at our{" "}
                <span className="boldsoff">Office</span> . Your working hours
                will be from Monday to Friday from 09:30 am to 05:30 pm. Your
                probation period will be for{" "}
                <span className="boldsoff">six months</span> . The completion of
                additional employment forms is part of this offer of employment
                and will be completed in person upon your arrival.
              </p>
              <p className="paraoff" style={{ margin: "30px 0" }}>
                Please note that your presence in the office is required as per
                business requirements and work from home is neither a mandate
                nor optional unless specified by HR. This offer letter is valid
                based on the submission and verification of all necessary
                documents, and liable to be revoked if any document/detail
                shared is untrue or does not match the verbal information or
                declaration shared during the process of the interview.
              </p>
              <p className="paraoff" style={{ margin: "30px 0" }}>
                You are required to report at our{" "}
                <span className="boldsoff">
                  No.73, Esic nagar,2nd floor, Santo complex,150ft agaram main
                  road, Thiruvancherry, Chennai-600126
                </span>{" "}
                for documentation and orientation on the day of your
              </p>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="paraoff">
                joining. Further, this offer of employment shall be deemed
                complete on your submission of credentials and documents
                mentioned under Annexure B herewith.
              </p>
              <p className="paraoff" style={{ margin: "30px 0" }}>
                Kindly sign and revert this document on or before <span style={{fontWeight:'bold'}}>{NextDateformat}</span>.
              </p>
              <p className="paraoff" style={{ margin: "30px 0" }}>
                We are confident that you will be able to make a significant
                contribution to the success of our Company and look forward to
                working with you.
              </p>
              <p className="boldsoff" style={{ marginTop: "25px" }}>
                For Keel Info Solution Private Limited
              </p>
              <div style={{ marginTop: "15px" }}>
                <img src={sign} width={"180px"} />
              </div>

              <div
                style={{
                  border: "1px dashed black",
                  margin: "29px 0px ",
                  marginRight: "15px",
                }}
              ></div>
              <p className="paraoff">
                I, <b>{capitalizeFirstLetter(RowIDdata[0]?.candidateName)}</b>, do hereby accept the offer as described in
                this letter and the related Annexures herewith. 
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  gap: "150px",
                }}
              >
                <p
                  className="paraoff"
                  style={{
                    marginTop: "40px",
                    borderTop: "1px solid black",
                    width: "50%",
                  }}
                >
                  Signature
                </p>
                <p
                  className="paraoff"
                  style={{
                    marginTop: "40px",
                    borderTop: "1px solid black",
                    width: "50%",
                  }}
                >
                  Date
                </p>
              </div>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="bol">Annexure A</p>
              <div
                style={{
                  display: "flex",
                  margin: "10px 40px",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "50%" }}>
                  <p className="para">
                    <span style={{ fontWeight: "800" }}>Name:</span> {" "}  {RowIDdata[0]?.candidateName}
                  </p>
                  <p className="para">
                    <span style={{ fontWeight: "800" }}>Designation:</span>{" "}
                    {RowIDdata[0]?.position}
                  </p>
                  <p className="para">
                    <span style={{ fontWeight: "800" }}>Grade:</span>{" "} A
                  </p>
                </div>

                <div style={{ width: "50%", marginLeft: "155px" }}>
                  <p className="para">
                    <span style={{ fontWeight: "800" }}>Location:</span>{" "}
                    {RowIDdata[0]?.location}
                  </p>
                  <p className="para">
                    <span style={{ fontWeight: "800" }}>Department:</span>{" "}
                    {RowIDdata[0]?.department}
                  </p>
                </div>
              </div>
              <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{margin:'30px 30px'}}
        >
          <thead>
            <tr style={headerStyle}>
              <td colSpan="3" style={{ textAlign: "left" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  <span>CTC ALLOCATION</span>
                  <span>{(Salarydata?.ctc / 12)?.toFixed(2)}</span>
                  <span>{Salarydata?.ctc}</span>
                </div>
              </td>
            </tr>

            <tr style={headerStyle}>
              <td>Salary Components</td>
              <td>Monthly</td>
              <td>Annually</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }} className="para">
                <b>Fixed (A)</b>
              </td>
            </tr>
            <tr>
              <td>{EarningData[0]?.componentName}</td>
              <td>{EarningData[0]?.monthly}</td>
              <td>{EarningData[0]?.yearly}</td>
            </tr>
            <tr>
              <td>{EarningData[1]?.componentName}</td>
              <td>{EarningData[1]?.monthly}</td>
              <td>{EarningData[1]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total (A)</b>
              </td>
              <td><b>{EarningData[0]?.monthly + EarningData[1]?.monthly} </b></td>
              <td><b>{EarningData[0]?.yearly + EarningData[1]?.yearly}</b></td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Reimbursement Basket (B)</b>
              </td>
            </tr>
            <tr>
              <td>{EarningData[2]?.componentName}</td>
              <td>{EarningData[2]?.monthly}</td>
              <td>{EarningData[2]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total (B)</b>
              </td>
              <td>{EarningData[2]?.monthly}</td>
              <td>{EarningData[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b>{EarningData[3]?.componentName} (C)</b>
              </td>
              <td>{EarningData[3]?.monthly}</td>
              <td>{EarningData[3]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Gross (D) = (A+B+C)</b>
              </td>
              {/* <td>{EarningData[0]?.monthly + EarningData[1]?.monthly + EarningData[2]?.monthly + EarningData[3]?.monthly } </td> */}
              <td><b>{(Salarydata?.gross)?.toFixed(2)}</b> </td>
              <td><b>{(Salarydata?.gross * 12)?.toFixed(2)}</b> </td>
            </tr>
            <tr>
              <td colSpan="3">
                <b>Deductions</b>
              </td>
            </tr>
            <tr>
              <td>{Deductiondata[1]?.componentName}</td>
              <td>{Deductiondata[1]?.monthly}</td>
              <td>{Deductiondata[1]?.yearly}</td>
            </tr>
            <tr>
              <td>{Deductiondata[0]?.componentName}</td>
              <td>{Deductiondata[0]?.monthly}</td>
              <td>{Deductiondata[0]?.yearly}</td>
            </tr>
            <tr style={totalRowStyle}>
              <td>
                <b>Total Deductions</b>
              </td>
              {/* <td>{Deductiondata[1]?.monthly + Deductiondata[0]?.monthly}</td> */}
              <td><b>{(Salarydata?.totalDeductions)?.toFixed(2)}</b></td>
              <td><b>{(Deductiondata[1]?.yearly + Deductiondata[0]?.yearly)?.toFixed(2)}</b></td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                <b>Benefits</b>
              </td>
            </tr>
            <tr>
              <td>{Benefitsdata[1]?.componentName}</td>
              <td>{Benefitsdata[1]?.monthly}</td>
              <td>{Benefitsdata[1]?.yearly}</td>
            </tr>
            <tr>
              <td>{Benefitsdata[0]?.componentName}</td>
              <td>{Benefitsdata[0]?.monthly}</td>
              <td>{Benefitsdata[0]?.yearly}</td>
            </tr>
            <tr>
              <td>{Benefitsdata[2]?.componentName}</td>
              <td>{Benefitsdata[2]?.monthly}</td>
              <td>{Benefitsdata[2]?.yearly}</td>
            </tr>
            <tr>
              <td>
                <b>Benefits Total (E)</b>
              </td>
              {/* <td>{Benefitsdata[1]?.monthly + Benefitsdata[0]?.monthly + Benefitsdata[2]?.monthly }</td> */}
              <td><b>{Salarydata?.totalBenefits}</b></td>
              {/* <td>{Benefitsdata[1]?.yearly + Benefitsdata[0]?.yearly + Benefitsdata[2]?.yearly }</td> */}
              <td><b>{(Salarydata?.totalBenefits * 12)?.toFixed(2)}</b></td>
            </tr>
            <tr>
              <td>
                <b>Monthly & Annual CTC </b>
              </td>
              <td><b>{(Salarydata?.ctc / 12)?.toFixed(2)}</b></td>
              <td><b>{Salarydata?.ctc}</b></td>
            </tr>
            <tr>
              <td>
                <b>Net Take Home </b>
              </td>
              <td><b>{Salarydata?.netPay}</b></td>
              <td><b>{(Salarydata?.netPay * 12)?.toFixed(2)}</b></td>
            </tr>
          </tbody>
        </table>
              <div
                style={{
                  display: "flex",
                  width: "80%",
                  justifyContent: "space-between",
                  marginTop: "0 0 0 15px",
                }}
              >
                <div style={{ marginLeft: "0px", marginTop: "-5%" }}>
                  <img src={sign} width={"180px"} />
                  <p className="boldsoff">People Manager</p>
                </div>
                <div style={{ marginTop: "5px", marginLeft: "0px" }}>
                  <p className="paraoff">I accept the above offer</p>
                </div>
              </div>
            </div>
          </ReusablePDFLayout>
          <ReusablePDFLayout>
            <div className="parentcls">
              <p className="boldsoff" style={{ textAlign: "center" }}>
                Annexure B
              </p>
              <p
                className="boldsoff"
                style={{ margin: "40px 0", textAlign: "center" }}
              >
                Documents for Employment
              </p>
              <p
                className="boldsoff"
                style={{ margin: "40px 0", textAlign: "center" }}
              >
                Kindly submit the photocopy of the below mentioned documents:
              </p>
              <div style={{ margin: "10px 95px", textAlign: "center" }}>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  1. <span>Relieving letter from your past employers.</span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  2.{" "}
                  <span>
                    Your educational certificates (starting from 10th std){" "}
                  </span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  3.{" "}
                  <span>
                    Proof of Salary Drawn – Copy of your appointment / revision
                    letter <br />
                    <span style={{ marginLeft: "16px" }}>
                      along with annual compensation package from your past
                      employer.
                    </span>{" "}
                  </span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  4. <span>Two numbers of passport size photograph. </span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  5. <span>PAN Card </span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  6. <span>Bank Passbook Front Page Xerox </span>
                </p>
                <p className="paraoff" style={{ margin: "15px 0" }}>
                  7. <span>Aadhar card </span>
                </p>
              </div>
              <p
                className="bolds"
                style={{ margin: "40px 90px", fontStyle: "italic" }}
              >
                *Please Note:{" "}
              </p>
              <p
                className="bolds"
                style={{ margin: "40px 30px 40px 90px", fontStyle: "italic" }}
              >
                We request you to bring both original and photocopies of your
                testimonials. Photocopies of the document will be verified and
                retained for our records. Originals will be returned to you{" "}
              </p>
            </div>
          </ReusablePDFLayout>
        </div>
      </div>
    </DashboardLayout>
  );
};
